import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { InfoCircleOutlined, RocketOutlined } from '@ant-design/icons';
import { formatDateTime } from '../../../../utils/functions';
import CommonTable from '../../../global/table';
import CommonCardView from '../../../global/cardView';
import NoRecordFound from '../../../global/noRecordFound';
import CommonDrawer from '../../../global/drawer';
import EnhancedLeadsSentCardView from './EnhancedLeadsSentCardView';
import EnhancedLeadsSentDetails from './EnhancedLeadsSentDetails';

const EnhancedLeadsSentList = ({
    isLoading,
    leadsSent,
    sort,
    setSort,
    viewType
}) => {
    const [leadDetails, setLeadDetails] = useState({
        show: false,
        data: null
    });



    // Columns Configuration
    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            sortType: "Name",
            isAvatar: true,
            render: (text, record) => (
                <div
                    className="cursor-pointer hover:text-primary font-medium"
                    onClick={() => setLeadDetails({ show: true, data: record.originalData })}
                >
                    {text}
                </div>
            )
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            sortType: "Email",
            render: (text) => (
                <p className='text-primary'>{text}</p>
            )
        },
        {
            title: "Phone",
            dataIndex: "phone",
            key: "phone",
            sortType: "Phone",
        },
        {
            title: "Sent At",
            dataIndex: "sentAt",
            key: "sentAt",
            sortType: "Sent At",
        },
        {
            title: "Destination",
            dataIndex: "destination",
            key: "destination",
            sortType: "Destination",
            render: (text) => (
                <span className="capitalize"><RocketOutlined className='mr-1' />{text}</span>
            )
        }
    ];

    // Data Mapping
    const data = Array.isArray(leadsSent) && leadsSent.length > 0
        ? leadsSent.map((item) => {
            const leadsInfo = item.LeadsInformation || {};
            return {
                ...item,
                key: item._id, // Assuming _id exists on the main item
                id: item._id,
                name: leadsInfo.fullName ? leadsInfo.fullName : `${leadsInfo.firstName} ${leadsInfo.lastName}`,
                email: leadsInfo.email,
                phone: leadsInfo.phone,
                destination: item.destinationId,
                sentAt: formatDateTime(item.dateAsPerUserTimezone),
                originalData: { ...item }
            }
        })
        : [];


    return (
        <>
            {data.length > 0 ? (
                <>
                    {viewType === "LIST" ? (
                        <CommonTable
                            columns={columns}
                            data={data}
                            sort={sort}
                            setSort={setSort}
                            onRowClick={(record) => setLeadDetails({ show: true, data: record.originalData })}
                            isLoading={isLoading}
                        />
                    ) : (
                        <CommonCardView>
                            {data.map((record) => (
                                <EnhancedLeadsSentCardView
                                    key={record.id}
                                    record={record}
                                    onCardClick={(record) => setLeadDetails({ show: true, data: record.originalData })}
                                />
                            ))}
                        </CommonCardView>
                    )}
                </>
            ) : (
                <NoRecordFound message="No leads sent history found." />
            )}

            {
                leadDetails.show && (
                    <CommonDrawer
                        open={leadDetails.show}
                        setOpen={() => setLeadDetails({ show: false, data: null })}
                        title="Lead Sent Details"
                        width={"800px"}
                        children={
                            <EnhancedLeadsSentDetails
                                leadDetail={leadDetails.data}
                            />
                        }
                    />
                )
            }
        </>
    );
};

export default EnhancedLeadsSentList;
